import { useTranslation } from 'react-i18next';
import { generatePath, useLocation } from 'react-router-dom';

// Import helpers
import { getTypeTranslation } from 'helpers';
import { PRODUCTS_TYPES } from 'helpers/variables';
import { VOD_PATHS } from 'components/routes/vod_routes/paths';

// Import utilities
import { useGeoblock } from 'components/utilities';

const { SERIES, MOVIE } = PRODUCTS_TYPES;

const usePlayButton = (uuid: string) => {
	const { t } = useTranslation();
	const { checkUserLocation, isLoading } = useGeoblock({ context: 'watch' });

	const { pathname } = useLocation();

	const isEpisode = pathname.split('/').includes(getTypeTranslation(SERIES));

	const type = isEpisode ? SERIES : MOVIE;
	const linkRedirect = generatePath(VOD_PATHS.PLAYER, { type: getTypeTranslation(type), id: uuid });

	const buttonText = t('vod_buttons_play');

	return {
		buttonText,
		linkRedirect,
		checkUserLocation,
		isLoading
	};
};

export default usePlayButton;
